import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      minHeight: 200,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
)

const NoData = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <span>No data available</span>
    </div>
  )
}

export default NoData
